import React from "react";
import Challenge from "./img/challenge-icon.svg?react";
import Special from "./img/special-icon.svg?react";
import Completed from "./img/completed-icon.svg?react";
import Quiz from "./img/quiz-icon.svg?react";
import UltraInsider from "./img/ultra-insider-poll.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

function contentSwitch(type = "") {
  const switchType = type?.toLowerCase();

  switch (switchType) {
    case "completed": {
      return [Completed, "Aktivität<br/>abgeschlossen"];
    }
    case "konkurs": {
      return [Challenge, "Wettbewerb"];
    }
    case "challenge": {
      return [Challenge, "Herausforderung"];
    }
    case "quiz": {
      return [Quiz, "Quiz"];
    }
    case "true/false": {
      return [Challenge, "Richtig/Falsch"];
    }
    case "puzzle": {
      return [Challenge, "Puzzle"];
    }
    case "ankieta": {
      return [UltraInsider, "Umfrage"];
    }
    case "ultra-insider-poll": {
      return [UltraInsider, "Umfrage"];
    }
    default: {
      return [Special, "Special"];
    }
  }
}

export default function ActivityType({ type = "" }) {
  const [Icon, copy] = contentSwitch(type);

  return (
    <div className={`activity-type-ultra-component`}>
      <div className="inner-content">
        <div className="icon">
          <Icon />
        </div>
        <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(copy)}} />
      </div>
    </div>
  );
}
